var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 15V16.875C21.5 17.9093 20.6585 18.75 19.625 18.75H3.5C1.8455 18.75 0.5 17.4045 0.5 15.75C0.5 15.75 0.5 3.01125 0.5 3C0.5 1.3455 1.8455 0 3.5 0H17.375C17.9967 0 18.5 0.504 18.5 1.125C18.5 1.746 17.9967 2.25 17.375 2.25H3.5C3.08675 2.25 2.75 2.586 2.75 3C2.75 3.414 3.08675 3.75 3.5 3.75H19.625C20.6585 3.75 21.5 4.59075 21.5 5.625V7.5H17.75C15.6823 7.5 14 9.18225 14 11.25C14 13.3177 15.6823 15 17.75 15H21.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 9V13.5H17.75C16.5073 13.5 15.5 12.4927 15.5 11.25C15.5 10.0073 16.5073 9 17.75 9H21.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.a81a3bfcdb1d715efb772e714a8d625a.svg";
export { ForwardRef as ReactComponent };